<template>
<div>
    <a href="#" @click="showModal()" class="caption round-medium card" :id="menu">
        <div class="caption round-medium shadow-huge bottom-10" >
            <!-- <div class="caption-bottom">
                <div class="caption-padding left-text">
                    <h5 class="color-white ultrabold">{{ title }}</h5><img v-bind:src="'images/mpower/banner/slide.png'" class="slide" :style="positionSlide">
                    <h5 class="under-heading color-white bottom-2">{{ description }}</h5>
                </div>
            </div> -->
            <img v-bind:src="'images/mpower-new/'+image" class="caption-image">
        </div>
    </a>
    </div>
</template>

<script>
export default {
  name: 'SliderSingle',
  props: {
    icon: String,
    title: String,
    description: String,
    color: String,
    image: String,
    modal: String,
    title2: String,
    description1: String,
    description2: String,
    image2: String,
    positionSlide2: String,
    link: String,
    menu: String,
   
    y1y2agentspvi: String,
    agentspvi: String,
    leaderpspvi: String,
    directunitpvi: String,
    grouppvi: String,

    badge: String
  },
  computed: {
    backgroundImg(){
        return {backgroundImage:'url(\'images/mpower-new/' + this.image + '\')'};
    },
    loadModal(){
        return this.modal
    },
    loadIcon(){
        return this.icon
    },
    loadTitle(){
        return this.title2
    },
    loadDescription1(){
        return this.description1
    },
    loadDescription2(){
        return this.description2
    },
    loadColor(){
        return this.color
    },
    loadImage(){
        return this.image2
    },
    loadPositionSlide2(){
        return this.positionSlide2
    },
    loadLink(){
        return this.link
    },
    loadMenu(){
        return this.menu
    },
    
    loadY1y2agentspvi(){
        return this.y1y2agentspvi
    },
    loadAgentspvi(){
        return this.agentspvi
    },
    loadLeaderpspvi(){
        return this.leaderpspvi
    },
    loadDirectunitpvi(){
        return this.directunitpvi
    },
    loadGrouppvi(){
        return this.grouppvi
    },
    
    loadBadge(){
        return this.badge
    },
    backgroundImg2(){
        return {
            'backgroundImage':'url(\'images/mpower-new/' + this.image + '\')',
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'background-position': 'center',
            'height': '191px'
        };
    },
    positionSlide(){
        // if(this.modal==='croatia-modal'){
            return {left: this.positionSlide2, top:'30%'};
        // }
        // else{
        //     return {left: this.positionSlide2};
        // }
    }
    },
    components:{
        // ExploreBannerContent
    },
    methods: {
      showModal() {
        document.querySelector(".header-s").style.display = "none";
        document.querySelector(".header").style.zIndex = "1";
        this.$modal.show(this.modal)
      },
      hideModal() {
        document.querySelector(".header-s").style.display = "block";
        document.querySelector(".header").style.zIndex = "96";
          this.$modal.hide(this.modal)
      },
      toggleModal() {
        // We pass the ID of the button that we want to return focus to
        // when the modal has hidden
        //this.$refs['my-modal'].toggle('#toggle-btn')
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-gradient{
    opacity: 0.8;
    background: none;
}
.caption-top{
    left: 7px;
    top: 40px;
}
.caption-bottom{
    background-color: #efcd89d1;
}
.caption-padding{
    padding: 0px 15px 0px;
}
h5{
    line-height: 24px;
}
.card img.slide{
    height: 20px;
    width: 20px;
    position: absolute;
    top: 0;
    left: 100px;
}
.owl-carousel .owl-item img {
    max-width: 700px;
}
</style>
